import * as Types from "../schemaTypes.generated";

import gql from "graphql-tag";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddUploadMutationVariables = Types.Exact<{
  id: Types.Scalars["uuid"];
  s3_key: Types.Scalars["String"];
  s3_level: Types.Scalars["String"];
  description?: Types.Maybe<Types.Scalars["String"]>;
  public_url?: Types.Maybe<Types.Scalars["String"]>;
}>;

export type AddUploadMutation = { __typename?: "mutation_root" } & {
  insert_uploads?: Types.Maybe<
    { __typename?: "uploads_mutation_response" } & Pick<
      Types.Uploads_Mutation_Response,
      "affected_rows"
    >
  >;
};

export const AddUploadDocument = gql`
  mutation AddUpload(
    $id: uuid!
    $s3_key: String!
    $s3_level: String!
    $description: String
    $public_url: String
  ) {
    insert_uploads(
      objects: {
        id: $id
        s3_key: $s3_key
        s3_level: $s3_level
        description: $description
        public_url: $public_url
      }
    ) {
      affected_rows
    }
  }
`;

export function useAddUploadMutation() {
  return Urql.useMutation<AddUploadMutation, AddUploadMutationVariables>(
    AddUploadDocument
  );
}
